import { ticketGroupTableActions } from 'store/actions';
import { workdeskFilterConstants } from 'store/constants';
import { Statuses, StatusI } from 'store/models/Statuses';
import TicketTypeHelper from 'store/models/TicketTypeHelper';
import { SortDirType } from 'store/models/workdesk-tickets/workdesk-tickets.interface';
import { TicketType } from 'store/models/TicketTypeHelper';
import {
  pingWsAfterSelector,
  selectedTicketTypeSelector,
  workdeskFilterSelectedStatusSelector,
} from 'store/selectors/workdesk-filter.selector';
import { workdeskTicketsActions } from 'store/actions/workdesk-tickets.actions';

const _setSearchValues = (searchValues: object) => {
  return {
    type: workdeskFilterConstants.SET_SEARCH_VALUES,
    payload: { searchValues },
  };
};

const setSearchValues = (searchValues: object) => {
  return (dispatch) => {
    dispatch(_setSearchValues(searchValues));
  };
};

const setHadCalledApi = (hadCalledApi: boolean) => {
  return {
    type: workdeskFilterConstants.SET_HAD_CALLED_API,
    payload: {
      hadCalledApi,
    },
  };
};

const toggleSortByOfField = (field: string, dir: SortDirType) => {
  return {
    type: workdeskFilterConstants.TOGGLE_SORT_BY_OF_FIELD,
    payload: { field, dir },
  };
};

const _toggleSelectedInbox = (address: string) => {
  return {
    type: workdeskFilterConstants.TOGGLE_SELECTED_INBOX,
    payload: { address },
  };
};

var timer: null | NodeJS.Timeout = null;
const toggleSelectedInbox = (address: string) => {
  return (dispatch, getState) => {
    const pingWsAfter = pingWsAfterSelector(getState());
    dispatch(_toggleSelectedInbox(address));
    console.debug(`toggleSelectedInbox: timer`, timer);
    if (timer) {
      console.debug(`toggleSelectedInbox: clear timer`);
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      console.debug(`toggleSelectedInbox: trigger load`);
      dispatch(
        workdeskTicketsActions.loadWorkdeskTickets(pingWsAfter),
      );
      timer = null;
    }, 1000);
    // reset select checkbox on the workdesk
    dispatch(ticketGroupTableActions.resetTicketGroupTableState());
  };
};

const setSelectedInboxes = (addresses: string[], value = true) => {
  return {
    type: workdeskFilterConstants.SET_SELECTED_INBOXES,
    payload: { addresses, value },
  };
};

const toggleSelectedStatus = (status: StatusI) => {
  if (!Statuses.isValidStatus(status)) throw Error(`invalid status`);
  return (dispatch, getState) => {
    const pingWsAfter = pingWsAfterSelector(getState());
    // save the selected status to session storage
    dispatch({
      type: workdeskFilterConstants.TOGGLE_SELECTED_STATUS,
      payload: {
        status,
      },
    });

    dispatch(workdeskTicketsActions.loadWorkdeskTickets(pingWsAfter));
    // reset select checkbox on the workdesk
    dispatch(ticketGroupTableActions.resetTicketGroupTableState());
  };
};

const toggleSelectedStatusIfIsNotCurrent = (status: StatusI) => {
  return (dispatch, getState) => {
    const selectedStatus = workdeskFilterSelectedStatusSelector(
      getState(),
    );
    if (!selectedStatus || selectedStatus !== status) {
      dispatch(toggleSelectedStatus(status));
    }
  };
};

const setHadWorkdeskFilterInLsOnInit = (value: boolean) => {
  return {
    type: workdeskFilterConstants.HAD_WORKDESK_FILTER_IN_LS_ON_INIT,
    payload: {
      workdeskFilterInLsOnInit: value,
    },
  };
};

const changeStartAtForStatus = (status: StatusI, startAt: number) => {
  return (dispatch, getState) => {
    const ticketType = selectedTicketTypeSelector(getState());
    dispatch({
      type: workdeskFilterConstants.CHANGE_START_AT_FOR_STATUS,
      payload: {
        status,
        startAt,
        ticketType,
      },
    });
  };
};

const _selectTicketType = (ticketType: TicketType) => {
  return {
    type: workdeskFilterConstants.SELECT_STATUS_TYPE,
    payload: { ticketType },
  };
};

const selectTicketType = (ticketType: TicketType) => {
  if (!ticketType) {
    throw Error(`TicketType is undefined`);
  }
  return (dispatch, getState) => {
    const pingWsAfter = pingWsAfterSelector(getState());
    dispatch(_selectTicketType(ticketType));
    dispatch(workdeskTicketsActions.loadWorkdeskTickets(pingWsAfter));
    // reset select checkbox on the workdesk
    dispatch(ticketGroupTableActions.resetTicketGroupTableState());
  };
};

const selectTicketTypeIfNotCurrentFromSiValue = (si: boolean) => {
  if (si === undefined) throw Error(`si is required`);
  return (dispatch, getState) => {
    const ticketType = TicketTypeHelper.getTicketTypeFromSi(si);
    const selectedTicketType = selectedTicketTypeSelector(getState());
    if (selectedTicketType !== ticketType) {
      dispatch(selectTicketType(ticketType));
    }
  };
};

const cacheBeforeLoadSelectedInboxes = () => {
  return {
    type: workdeskFilterConstants.CACHE_BEFORE_LOAD_SELECTED_INBOXES,
  };
};

const restoreSelectedInboxesFromBeforeLoad = () => {
  return {
    type:
      workdeskFilterConstants.RESTORE_FROM_BEFORE_LOAD_SELECTED_INBOXES,
  };
};

export const workdeskFilterActions = {
  toggleSelectedInbox,
  setSelectedInboxes,
  toggleSelectedStatus,
  selectTicketType,
  selectTicketTypeIfNotCurrentFromSiValue,
  toggleSortByOfField,
  changeStartAtForStatus,
  setHadWorkdeskFilterInLsOnInit,
  setSearchValues,
  toggleSelectedStatusIfIsNotCurrent,
  setHadCalledApi,
  cacheBeforeLoadSelectedInboxes,
  restoreSelectedInboxesFromBeforeLoad,
};
